/* eslint-disable import/prefer-default-export */

export const UPDATE_PARTNERSHIP_FIRST_NAME = 'UPDATE_PARTNERSHIP_FIRST_NAME';
export const UPDATE_PARTNERSHIP_LAST_NAME = 'UPDATE_PARTNERSHIP_LAST_NAME';
export const UPDATE_PARTNERSHIP_EMAIL = 'UPDATE_PARTNERSHIP_EMAIL';
export const UPDATE_PARTNERSHIP_HOST = 'UPDATE_PARTNERSHIP_HOST';
export const PARTNERSHIP_CHANGED = 'PARTNERSHIP_CHANGED';
export const ORGANIZATION_NAMES_CHANGED = 'ORGANIZATION_NAMES_CHANGED';
